// extracted by css-extract-rspack-plugin
export default {"sidebar":"Gr1JA"};